var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var activeClass = 'is-active',
    eventName   = 'tick.slides',
    delay = 5000;

function getNextElement($collection, activeClass) {
    var index = $collection.filter('.' + activeClass).index();
    var maxIndex = $collection.length - 1;
    var nextItem;

    // If it's the last item, or doesn't exist, then select the first one.
    if (index === -1 || index >= maxIndex) {
        nextItem = $collection.eq(0);
    } else {
        nextItem = $collection.eq(index + 1);
    }
    return nextItem;
}

function setClasses($collection, activeClass, $item) {
    $collection.removeClass(activeClass).filter($item).addClass(activeClass);
}

function startTick($collection, eventName) {
    $collection.parent().trigger(eventName);
}


$(function () {
    var $slidesWrap = $('.slides__canvas'),
        $slides = $slidesWrap.find('.slides__slide'),

        $taglines = $('.home-img__tagline');

        $slidesWrap.on(eventName, function () {
            var $item = getNextElement($slides, activeClass);
            setClasses($slides, activeClass, $item);

            var $tagline = getNextElement($taglines, activeClass);
            setClasses($taglines, activeClass, $tagline);
        });

    startTick($slides, eventName);
    window.setInterval(function () {
        startTick($slides, eventName);
    }, delay);
});
